export default "__VITE_ASSET__a579af60__"